export default "__VITE_ASSET__DLWQOk78__"